module.exports = __webpack_public_path__ + "img/support_f1.68ae94a4.png";